import React from 'react'
import Footer from '../../Layout/Footer';

const RefundPolicy = () => {
    return (
        <>
            {/* Navigation */}
            <nav>
                <div className="nav-container">
                    <h1 className="logo">Raivens Technologies</h1>
                    <div className="nav-buttons">
                        <a href="/login" className="button button-primary">Login</a>
                        <a href="/login" className="button button-primary">Register</a>
                    </div>
                </div>
            </nav>
            <div className='common-wrap'>
                <div className='container'>
                    <h2 className='section-title mb-4'><strong>Refund & Return Policy</strong></h2>
                    <div className='content'>
                        <p><strong>Last Updated: 18-03-2025</strong></p>
                        <p>At Raivens Technologies Pvt. Ltd., customer satisfaction is our top priority. If you are not completely satisfied with your purchase, we offer a 10-day return policy to ensure a hassle-free experience.</p>

                        <h3>1. Return Policy</h3>
                        <ul>
                            <li>You have 10 days from the date of delivery to request a return. To be eligible for a return, your item must:</li>
                            <ul>
                                <li>Be in the same condition as received (unused, unworn, with original tags and packaging).</li>
                                <li>Include the receipt or proof of purchase.</li>
                            </ul>
                            <li>To initiate a return, contact us at <a href="mailto:info@raivens.com">info@raivens.com</a>. Once your return request is approved, we will provide a return shipping label and instructions on how to send your package.</li>
                        </ul>
                        <p><strong>📍 Return Address:</strong><br />
                            Raivens Technologies Pvt. Ltd.<br />
                            Sonwa Road, Tonk, Rajasthan - 304001<br />
                            <strong>📞 WhatsApp Support:</strong> +91 9358409099<br />
                            🚨 Important: Returns sent without prior approval will not be accepted.
                        </p>

                        <h3>2. Damages & Issues</h3>
                        <p>If you receive a damaged, defective, or incorrect item, please inspect your order immediately upon delivery and contact us within 24 hours. We will evaluate the issue and provide a replacement or refund as needed.</p>

                        <h3>3. Non-Returnable Items</h3>
                        <p>Certain products cannot be returned, including:</p>
                        <ul>
                            <li>Custom-made or personalized items (special orders).</li>
                            <li>Hazardous materials, flammable liquids, or gases.</li>
                            <li>Gift cards or digital purchases.</li>
                            <li>Discounted or sale items (final sale).</li>
                        </ul>
                        <p>If you have any concerns about your specific item, please reach out before placing your return request.</p>

                        <h3>4. Exchange Policy</h3>
                        <p>If you need a different item, the best way is to return your original purchase, and once approved, place a new order. This ensures you receive your preferred item without delays.</p>

                        <h3>5. European Union 14-Day Cooling-Off Period</h3>
                        <p>For EU customers, you have the right to cancel or return your order within 14 days of delivery, without needing to provide a reason. Your item must be:</p>
                        <ul>
                            <li>Unused, unworn, with original tags and packaging.</li>
                            <li>Accompanied by proof of purchase.</li>
                        </ul>

                        <h3>6. Refund Process</h3>
                        <ul>
                            <li>Once we receive and inspect your return, we will notify you of approval or rejection. If approved:</li>
                            <ul>
                                <li>Refunds will be processed to your original payment method within 10 business days.</li>
                                <li>Please note that your bank or payment provider may take additional time to process the refund.</li>
                            </ul>
                            <li>🚨 If you haven’t received your refund within 15 business days, contact us at <a href="mailto:info@raivens.com">info@raivens.com</a> for assistance.</li>
                        </ul>

                        <h3>Need Help?</h3>
                        <p>For any return, exchange, or refund inquiries, feel free to reach out:</p>
                        <p><strong>📍 Company Address:</strong><br />
                            Raivens Technologies Pvt. Ltd.<br />
                            Sonwa Road, Tonk, Rajasthan - 304001<br />
                            <strong>📍 Shipping Address:</strong><br />
                            Raivens Technologies Pvt. Ltd.<br />
                            Plot No 4, Laxmi Vilas, Choudhary Colony, Sawai Madhopur Road, Tonk, Rajasthan, India - 304001<br />
                            <strong>📞 WhatsApp Support:</strong> +91 8696606662<br />
                            <strong>📧 Email Support:</strong> <a href="mailto:info@raivens.com">info@raivens.com</a>
                        </p>
                        <p>We are happy to assist you and ensure a smooth return process. 🚀</p>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default RefundPolicy;
